import axios from 'axios';

export class FlightService {

    private static HEADERS = { 'Content-Type': 'application/json' };

    private static getBaseUrl() {
        return process.env.VUE_APP_FLIGHT_CONNECTOR_V2_BASE_URL || window.env.VUE_APP_FLIGHT_CONNECTOR_V2_BASE_URL
    }

    static async callApiToSqs(data: any): Promise<any> {
        const response = await axios.put(`${this.getBaseUrl()}/flight-details-api-2-sqs`, data, { headers: this.HEADERS });
        return response.data;
    }

    static async getFlightDetails(boReference: string) {
        const response = await axios.get(`${this.getBaseUrl()}/flight-details/${boReference}`, { headers: this.HEADERS });
        return response.data;
    }


}